import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import {
  reportMenuItemStyle,
  reportSelectStyle,
} from "./attendanceReportUi";

interface AttendanceReportFilterBarProps {
  courses: string[];
  batches: string[];
  purposes?: string[];
  course: string;
  batch: string;
  purpose?: string;
  disabled?: boolean;
  showPurpose?: boolean;
  showCourseAll?: boolean;
  purposeLabel?: (value: string) => string;
  onCourseChange: (value: string) => void;
  onBatchChange: (value: string) => void;
  onPurposeChange?: (value: string) => void;
}

export function AttendanceReportFilterBar({
  courses,
  batches,
  purposes = [],
  course,
  batch,
  purpose = "All",
  disabled = false,
  showPurpose = true,
  showCourseAll = true,
  purposeLabel = (value) => value,
  onCourseChange,
  onBatchChange,
  onPurposeChange,
}: AttendanceReportFilterBarProps) {
  return (
    <>
      <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
        <InputLabel style={{ fontSize: "14px", fontFamily: "inherit" }}>
          Course
        </InputLabel>
        <Select
          value={course}
          label="Course"
          disabled={disabled}
          onChange={(e) => onCourseChange(String(e.target.value))}
          style={reportSelectStyle}
        >
          {showCourseAll && (
            <MenuItem value="All" style={reportMenuItemStyle}>
              All
            </MenuItem>
          )}
          {courses.map((item) => (
            <MenuItem key={item} value={item} style={reportMenuItemStyle}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
        <InputLabel style={{ fontSize: "14px", fontFamily: "inherit" }}>
          Batch
        </InputLabel>
        <Select
          value={batch}
          label="Batch"
          disabled={disabled}
          onChange={(e) => onBatchChange(String(e.target.value))}
          style={reportSelectStyle}
        >
          <MenuItem value="All" style={reportMenuItemStyle}>
            All
          </MenuItem>
          {batches.map((item) => (
            <MenuItem key={item} value={item} style={reportMenuItemStyle}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showPurpose && (
      <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
        <InputLabel style={{ fontSize: "14px", fontFamily: "inherit" }}>
          Purpose
        </InputLabel>
        <Select
          value={purpose}
          label="Purpose"
          disabled={disabled}
          onChange={(e) => onPurposeChange?.(String(e.target.value))}
          style={reportSelectStyle}
        >
          <MenuItem value="All" style={reportMenuItemStyle}>
            All
          </MenuItem>
          {purposes.map((item) => (
            <MenuItem key={item} value={item} style={reportMenuItemStyle}>
              {purposeLabel(item)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      )}
    </>
  );
}
